(function () {
  const BADGE_ID = "mp-pulse-badge";
  const CENTER_BADGE = false;

  // CSS einbetten
  const style = document.createElement("style");
  style.textContent = `
    .mp-pulse-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 12px;
  font-family: inherit;
  color: #000000CF;
  width: 100%;
}
    .mp-pulse-badge.mp-center {
      justify-content: center;
      width: 100%;
    }
    .mp-pulse-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #22c55e;
      flex-shrink: 0;
      animation: mp-pulse 1.8s ease-in-out infinite;
    }
    @keyframes mp-pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(0.85); }
    }
    .mp-badge-text-content {
      font-weight: 500;
    }
  `;
  document.head.appendChild(style);

  function getBadgeText() {
  const country = window.Shopify && window.Shopify.country;
  if (country === 'DE') {
    return "In 1–2 Tagen versandbereit ·  Versand nur 4,95€";
  }
  if (country === 'AT') {
    return "In 1–2 Tagen versandbereit · Versand ab 9,99€";
  }
  if (country === 'CH') {
    return "In 1–2 Tagen versandbereit · Versand ab 15 CHF";
  }
  return "In 1–2 Tagen versandbereit";
}

  function isProductPage() {
    if (document.body && document.body.classList.contains("template-product")) return true;
    return /^\/products\/.+/.test(location.pathname);
  }

  function createBadge() {
    const badge = document.createElement("div");
    badge.id = BADGE_ID;
    badge.className = "mp-pulse-badge" + (CENTER_BADGE ? " mp-center" : "");
    badge.setAttribute("role", "status");
    badge.setAttribute("aria-live", "polite");

    const dot = document.createElement("span");
    dot.className = "mp-pulse-dot";

    const text = document.createElement("span");
    text.className = "mp-badge-text-content";
    text.textContent = getBadgeText();

    badge.appendChild(dot);
    badge.appendChild(text);
    return badge;
  }

  function placeBadge() {
    if (!isProductPage()) return;
    const target = document.querySelector('.tee-btn--atc');
    if (!target) return;
    const existing = document.getElementById(BADGE_ID);
    if (existing && existing.nextElementSibling === target) return;
    const badge = existing || createBadge();
    target.parentNode.insertBefore(badge, target);
  }

  function boot() {
    if (!isProductPage()) return;
    let attempts = 0;
    const interval = setInterval(() => {
      placeBadge();
      attempts++;
      if (attempts >= 20 || document.getElementById(BADGE_ID)) {
        clearInterval(interval);
      }
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();